// JSON helpers that keep 64-bit ids intact.
//
// The API generates ids with snowflake (int64, 19 digits) and JSON.parse
// rounds anything above 2^53. Responses are parsed with big integers turned
// into strings, requests are serialized with those strings turned back
// into plain numbers, so Go side still receives int values.

// integer literal as a JSON value (after ':' / '[' / ',') with 16+ digits
const bigNumberValue = /([:[,]\s*)(-?\d{16,})(?=\s*[,\]}])/g

// quoted 16+ digit string as a JSON value, not followed by ':' (so keys are skipped)
const bigStringValue = /([:[,]\s*)"(-?\d{16,})"(?!\s*:)/g

export default {

  // JSON text -> object, big ints become strings
  parse(text){
    if (text == null || text === '') return undefined
    if (typeof text != 'string') return text
    return JSON.parse(text.replace(bigNumberValue, '$1"$2"'))
  },

  // object -> JSON text, numeric strings with 16+ digits become numbers
  stringify(value){
    let text = JSON.stringify(value)
    if (text == null) return text
    return text.replace(bigStringValue, '$1$2')
  },

  // id from a route param: short digits become a number (Go wants int),
  // 16+ digits stay a string, stringify sends them as a number anyway
  id(v){
    if (typeof v == 'string' && /^-?\d{1,15}$/.test(v)) return Number(v)
    return v
  },

  // true for a value that looks like an id (number or digits-only string)
  isID(v){
    if (typeof v == 'number') return Number.isInteger(v) && v > 0
    return typeof v == 'string' && /^\d+$/.test(v)
  },

}
